import { render, staticRenderFns } from "./Mascota.vue?vue&type=template&id=6460ac7e&scoped=true&"
import script from "./Mascota.vue?vue&type=script&lang=js&"
export * from "./Mascota.vue?vue&type=script&lang=js&"
import style0 from "./Mascota.vue?vue&type=style&index=0&id=6460ac7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460ac7e",
  null
  
)

export default component.exports